const KEY = "recruit_iq_settings_v1";
const SID = "recruit_iq_session_id";

export function getSettings() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {
      provider: "anthropic", model: "claude-3-5-sonnet-20241022", apiKey: "",
    };
  } catch {
    return { provider: "anthropic", model: "claude-3-5-sonnet-20241022", apiKey: "" };
  }
}

export function saveSettings(s) {
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function hasKey() {
  return Boolean((getSettings().apiKey || "").trim());
}

export function getSessionId() {
  let id = localStorage.getItem(SID);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || (Math.random().toString(36).slice(2) + Date.now());
    localStorage.setItem(SID, id);
  }
  return id;
}
